<template>
  <section class="sm-settings__top">
    <div class="sm-settings__top-inner">
      <div class="sm-settings__top-flex">
        <div class="sm-settings__top-row">
          <div class="sm-settings__top-title">
            <a href="#" @click.prevent="$router.push('settings')">
              <include-svg :name="'icon-settings-sec'" />
            </a>
            <h2>Settings</h2>
          </div>
          <tabs-elem :tabs="allTabs" :scroll="true" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import IncludeSvg from '@/components/IncludeSvg';
import Tabs from '@/components/Tabs';
import { mapGetters } from 'vuex';

export default {
  name: 'settings-top',
  components: {
    'include-svg': IncludeSvg,
    'tabs-elem': Tabs
  },
  data() {
    return {
      tabs: [
        {
          tab: 'company',
          text: 'Business Profile',
          except: ['mail_admin']
        },
        {
          tab: 'general',
          text: 'General',
          except: ['mail_admin']
        },
        {
          tab: 'coupons',
          text: 'Coupons',
          levels: [2, 3],
          except: ['mail_admin']
        },
        {
          tab: 'plans',
          text: 'Plans',
          levels: [2, 3],
          except: ['mail_admin']
        },
        {
          tab: 'payments',
          text: 'Payments',
          except: ['mail_admin']
        },
        {
          tab: 'other',
          text: 'Integrations',
          levels: [2, 3],
          except: ['mail_admin', 'admin']
        },
        {
          tab: 'service',
          text: 'Service',
          levels: [1],
          except: ['mail_admin', 'admin']
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      provider: 'provider',
      userAccount: 'account/userAccount'
    }),
    allTabs() {
      let res = [];
      let role = this.userAccount.role;
      this.tabs.forEach(tab => {
        if (tab.except && role && tab.except.includes(role)) {
          return;
        }
        if (tab.levels && this.provider.client_level && !tab.levels.includes(this.provider.client_level))
          return;

        res.push(tab);
      });

      return res;
    }
  },
  created() {
  },
  methods: {

  }
}
</script>
